import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Action from '../../Action';
import Loader from '../../Atoms/Loader';

import * as style from './style.module.css';

const parseFloatingHint = (nb) => {
  if (typeof nb === 'string') {
    return nb;
  }
  if (!nb || nb <= 0) {
    return '';
  }
  if (nb > 99) {
    return '99+';
  }
  return `${nb}`;
};

const Button = ({ label = '', title = '', loading = false, icon = null, floatingHintIcon = null, floatingHintColor = 'DANGER', iconOnlyOnMobile = false, active = false, disabled = false, className = '', theme = 'PRIMARY', size = 'MEDIUM', hint = 0, floatingHint = 0, action = null, ...props }) => {
  const parsedLabel = `${label}`.trim();
  const hasHint = typeof hint === 'string' ? hint.length > 0 : hint > 0;
  return (
    <Action
      action={disabled || loading ? null : action}
      title={parsedLabel || title}
      className={`${style.button} ${active ? style.active : ''} ${iconOnlyOnMobile ? style.iconOnlyOnMobile : ''} ${style[theme.toLowerCase()]} ${loading ? style.loading : ''} ${style[size.toLowerCase()]} ${disabled ? style.disabled : ''} ${parsedLabel ? style.text : ''
        } ${className}`}
      {...props}
    >
      {icon && <FontAwesomeIcon className={style.icon} icon={icon} />}
      {loading && <Loader className={style.loader} />}
      <span className={style.text}>{parsedLabel}</span>
      {hasHint && <span className={style.hint}>{hint}</span>}
      {(typeof floatingHint === 'string' || floatingHint > 0) && <div className={`${style.floatingHint} ${style[floatingHintColor?.toLowerCase()] || ''}`}>{parseFloatingHint(floatingHint)}</div>}
      {floatingHint <= 0 && floatingHintIcon && <div className={`${style.floatingHint} ${style[floatingHintColor?.toLowerCase()] || ''}`}><FontAwesomeIcon icon={floatingHintIcon} /></div>}
    </Action>
  );
};

export default React.memo(Button);
